import { useState } from "react"

const OverlayForm = () => {
    const [project, setProject] = useState({
        name: '',
        link: 'https://www.',
        img_name: 'https://www.',
        img_desc: ''
    })
    const handleChange = (e) => {
        setProject((prev) => ({ ...prev, [e.target.name]: e.target.value }))
    }

    return (
        <section className={`hidden fixed z-40 w-screen h-screen top-0 left-0 bg-gray-800 opacity-80 overflow-hidden`}>
            <div className="container w-screen h-screen mx-auto">
                <div className="w-full h-full flex flex-col justify-center items-center p-6">
                    <h2 className="mb-11 font-heading font-bold text-white text-5xl sm:text-6xl">Portfolio Project</h2>
                    <div className="flex flex-wrap max-w-md mx-auto -m-2 mb-5">
                        <div className="w-full p-2">
                            <input className="w-full px-5 py-3.5 text-black placeholder-gray-500 bg-white outline-none focus:ring-2 focus:ring-green-500 border border-gray-200 rounded-lg" type="text" placeholder="Project Name" value={project.name} name="name" onChange={handleChange} />
                        </div>
                        <div className="w-full p-2">
                            <input className="w-full px-5 py-3.5 text-black placeholder-gray-500 bg-white outline-none focus:ring-2 focus:ring-green-500 border border-gray-200 rounded-lg" type="text" placeholder="Project Link" value={project.link} name="link" onChange={handleChange} />
                        </div>
                        <div className="w-full p-2">
                            <input className="w-full px-5 py-3.5 text-black placeholder-gray-500 bg-white outline-none focus:ring-2 focus:ring-green-500 border border-gray-200 rounded-lg" type="text" placeholder="Image Link" value={project.img_name} name="img_name" onChange={handleChange} />
                        </div>
                        <div className="w-full p-2">
                            <textarea className="w-full px-5 py-3.5 text-black placeholder-gray-500 bg-white outline-none focus:ring-2 focus:ring-green-500 border border-gray-200 rounded-lg" type="text" placeholder="Image Description" name="img_description" defaultValue={project.img_desc} onChange={handleChange}></textarea>
                        </div>
                        <div className="w-full p-2">
                            <div className="group relative">
                                <div className="absolute top-0 left-0 w-full h-full bg-gradient-green opacity-0 group-hover:opacity-50 rounded-lg transition ease-out duration-300"></div>
                                <button className="p-1 w-full font-heading font-bold text-base text-black overflow-hidden rounded-md">
                                    <div className="relative py-4 px-9 bg-gradient-green overflow-hidden rounded-md hover:text-white">
                                        <div className="absolute top-0 left-0 transform -translate-y-full group-hover:-translate-y-0 h-full w-full bg-gray-900 transition ease-in-out duration-500"></div>
                                        <p className="relative z-10">Add New Project</p>
                                    </div>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default OverlayForm